<template>
  <div class="halfPage">
    <div class="table-title">
      <b>{{ title }}</b>
    </div>

    <v-data-table
      :items="items"
      :headers="detailsHeaders"
      class="elevation-1 child"
      :disable-pagination="true"
      :no-data-text="tableText"
      :hide-default-footer="true"
    >
      <template v-slot:[`item.Mablagh`]="{ item }">
        {{ normalizeNumber(item.Mablagh) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: ["tableText", "items", "title"],

  methods: {
    normalizeNumber(number) {
      return this.numberWithCommas(number) + " ریال";
    },
  },
  data() {
    return {
      detailsHeaders: [
        {
          text: "عنوان",
          value: "Fname",
          width: "60%",
        },
        {
          text: "مبلغ",
          value: "Mablagh",
          width: "40%",
        },
      ],
    };
  },
};
</script>
<style scoped>

.separator {
  margin: 15px;
  border: none;
  height: 3px;
  /* Set the hr color */
  color: #333; /* old IE */
  background-color: #333; /* Modern Browsers */
}
</style>
